module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/SanGabriels-log_BW-p-130x130q80-d19369e93033793d0a2527ed54de5bbb.jpg";